module.exports = __webpack_public_path__ + "img/star-nebula-0.d2cb5790.png";